import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  todo:"",
  todos: "",
};

const todoSlice = createSlice({
  name: "todo",
  initialState: initialState,
  reducers: {
    setTodo(state, payload) {
      // console.log(payload.payload.response);
      state.todo = payload.payload.response;
  },
    getTodos(state, payload) {
      state.todos = payload.payload.response;
    },
    updateTodos(state, payload) {
      state.todo = payload.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default todoSlice.reducer;
export const todoActions = todoSlice.actions;
